import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { deleteTrainingSessionExercise, getTrainingSessionExerciseSingle } from "../../../../services/training-session";
import { emptyTrainingSessionExercise, TrainingSessionExercise } from "../../../../interfaces/training-session";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface CoachTrainingSessionExerciseDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function CoachTrainingSessionExerciseDelete(props: CoachTrainingSessionExerciseDeleteProps) {
    const [trainingSessionExercise, setTrainingExercise] = useState<TrainingSessionExercise>(emptyTrainingSessionExercise);

    const handleDelete = () => {
        deleteTrainingSessionExercise(props.id)
            .then(response => {
                props.onDelete(props.id);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getTrainingSessionExerciseSingle(props.id)
            .then(response => {
                setTrainingExercise(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="training-exercise-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_training_session_exercise") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { trainingSessionExercise.id == 0 && 
                    <LoadingSpinner />
                }
                { trainingSessionExercise.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_training_session_exercise_message"
                                values={{
                                    training_session_exercise_name: trainingSessionExercise.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
